var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"curve-shape"},[_c('svg',{staticStyle:{"overflow":"scroll","enable-background":"new 0 0 3841 120"},attrs:{"x":"0px","y":"0px","viewBox":"0 0 3841 120","xml:space":"preserve"}},[_vm._t("bgcolor")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }